<script>
import Layout from '@layouts/main';
import QuoteForm from '@views/quotes/form';

export default {
  components: {
    Layout,
    QuoteForm,
  },
  page() {
    return {
      title: this.$t('titles.create_quote'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.quotes'),
          to: { name: 'quotes.index' },
        },
        {
          text: this.$t('titles.create_quote'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create(quote) {
      this.$router.push({
        name: 'quotes.edit',
        params: {
          id: quote.id,
        },
        query: {
          create: 1,
        },
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_quote')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <QuoteForm @submitted="create" />
    </b-card>
  </Layout>
</template>
